import DOMPurify from 'dompurify';
(function ($) {
    var HC_CARD = 'credit card';
    var HC_BANKACC = 'bank account';

    $.widget('ca.caMembershipApplication', {
        _create: function () {
            this.hidePreloader();

            this.element.find('.clickable-steps a').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var gotostep = $(this).data('gotostep');
            });

            this.element.on('click', '.ma-toggle-button button', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var val = $(this).data('value');
                $(this).siblings('input[type=hidden]').val(val);
                $(this).siblings('button').addClass('btn-alt');
                $(this).removeClass('btn-alt');
            });

            cpac.user.billing.initCreditCardForm();

            var self = this;

            function changeState() {
                var state = History.getState();
                switch (state.data.path) {
                    case 'membership-application':
                        var $step = self.element.find('#ma-step1');
                        if ($step.find('>form').length > 0) {
                            self.element.find('>.step').hide();
                            $step.show();
                            self.setActiveTab(1);
                        } else {
                            self.showPreloader();
                            $.get("/membership-application/info").done(function (data) {
                                if (data.html) {
                                    $step.html(data.html);

                                    if ($('#ma_country_code').length) {
                                        $('.select-plain').each(function (i, element) {
                                            $(element).selectPlain();
                                        });
                                    }

                                    self.element.find('>.step').hide();
                                    $step.show();
                                    if ($step.find('>form').length) {
                                        self.initStep1();
                                    }
                                }
                                self.hidePreloader();
                            });
                        }
                        break;

                    case 'review-information':
                        var $step = self.element.find('#ma-step2');
                        if ($step.find('>form').length > 0) {
                            self.element.find('>.step').hide();
                            $step.show();
                            self.setActiveTab(2);
                        } else {
                            $.get("/membership-application/review").done(function (data) {
                                if (data.html) {
                                    $step.html(data.html);
                                    self.element.find('>.step').hide();
                                    $step.show();
                                    self.initStep2(data.html);
                                }
                                if (data.errors || data.message) {
                                    History.back();
                                }
                                self.hidePreloader();
                            });
                        }
                        break;

                    case 'electronic-contract':
                        var $step = self.element.find('#ma-step3');
                        if ($step.find('>div').length > 0) {
                            self.element.find('>.step').hide();
                            $step.show();
                            self.setActiveTab(3);
                        } else {
                            $.get("/membership-application/contract").done(function (data) {
                                if (data.html) {
                                    $step.html(data.html);
                                    self.element.find('>.step').hide();
                                    $step.show();
                                    self.initStep3(data.html);
                                }
                                if (data.errors || data.message) {
                                    History.back();
                                }
                                self.hidePreloader();
                            });
                        }
                        break;

                    case 'payment-screen':
                        var $step = self.element.find('#ma-step4');
                        if ($step.find('>div').length > 0) {
                            self.element.find('>*').show();
                            self.element.find('>.step').hide();
                            $step.show();
                            var tab = self.options.hasContract ? 4 : 3;
                            self.setActiveTab(tab);
                        } else {
                            $.get("/membership-application/payment").done(function (data) {
                                if (data.html) {
                                    $step.html(data.html);
                                    self.element.find('>*').show();
                                    self.element.find('>.step').hide();
                                    if ($('#ma_country_code').length) {
                                        $('.select-plain').each(function (i, element) {
                                            $(element).selectPlain();
                                        });
                                    }
                                    $step.show();
                                    self.initStep4(data.html);
                                }
                                if (data.errors || data.message) {
                                    History.back();
                                }
                                self.hidePreloader();
                            });
                        }
                        break;

                    case 'thank-you':
                        var $step = self.element.find('#ma-step5');
                        self.element.find('>*').hide();
                        $step.show();
                        break;
                }
            }

            if (self.options.hasError) {
                return;
            }

            History.Adapter.bind(window, 'statechange', function () {
                changeState();
            });

            var state = History.getState();
            if (!state.data.path) {
                window.History.replaceState(
                    {
                        path: 'membership-application'
                    },
                    'Membership Application',
                    state.url + '&tab=1'
                );
            } else {
                changeState();
            }
        },

        showPreloader: function () {
            $('.ma-preloader').show();
        },

        hidePreloader: function () {
            $('.ma-preloader').hide();
        },

        setActiveTab: function (n) {
            var $li = $('#membership_application .nav li');
            $li.removeClass('active');
            $($li.get(n - 1)).addClass('active');
        },

        initStep1: function () {
            this.setActiveTab(1);
            var $form = this.element.find('#ma-step1 > form');
            var self = this;

            function getData() {
                function getInputVal(name, form) {
                    return $('input[name=' + name + ']', form || $form).val();
                }

                function birthdayFormat(name, $container) {
                    var date = [];
                    $('[name="' + name + '[]"]', $container || $form).each(function () {
                        var value = $(this).val();
                        if (!value) {
                            return [];
                        }

                        date.push(value);
                    });

                    return date.join('/');
                }

                var data = {
                    first_name: getInputVal('owner_first_name'),
                    last_name: getInputVal('owner_last_name'),
                    birthday: getInputVal('owner_birthday'),
                    sex: getInputVal('owner_sex')
                };

                if ($form.find('.ma-spouse-block .form-fields').is(':visible')) {
                    data.secondary = {
                        id: $('.ma-data-spouse').data('id'),
                        first_name: getInputVal('secondary_first_name'),
                        last_name: getInputVal('secondary_last_name'),
                        birthday: getInputVal('secondary_birthday'),
                        sex: getInputVal('secondary_sex')
                    };
                }

                var children = $form.find('.ma-child-block .form-fields').is(':visible');
                if (children) {
                    data.children = [];
                    $form.find('.ma-child-block .form-fields:visible').each(function () {
                        data.children.push({
                            id: $(this).closest('.ma-child-block').data('id'),
                            first_name: getInputVal('child_first_name', this),
                            last_name: getInputVal('child_last_name', this),
                            birthday: getInputVal('child_birthday', this),
                            sex: getInputVal('child_sex', this)
                        });
                    });
                }

                var otherData = $form.find('.serializable').find(':input').serializeArray();

                $.each(otherData, function () {
                    data[this.name] = this.value;
                });

                return data;
            }

            function setupDefaultConfiguration() {
                if (self.options.withSecondary) {
                    $form.find('.ma-add-spouse').hide();
                    $form.find('.ma-spouse-block').show();
                }

                if (self.options.withDependents) {
                    var $block = $form.find('.ma-child-block');
                    var $clone = $block.clone();
                    $block.find('.ma-add-child').hide();
                    $block.find('.ma-del-child').show();
                    $block.show();
                    $clone.find('#ma_child_birthday').addClass('cloned-DatePicker').caDatePickerProUI();
                    $block.after($clone);
                    $block.addClass('child-visible');
                    $clone.find('.ma-del-child').hide();
                    $clone.find('.ma-add-child').show();
                    $clone.find('.form-fields').hide();
                    $clone.show();

                    var count = $block.siblings('.child-visible').length + 1;
                    var max = self.options.maxDependents;
                    if (max > 0 && count >= max) {
                        $clone.find('.ma-add-child').hide();
                    }
                }
            }

            function setupFormHandlers() {
                $form.on('click', '.ma-add-child', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var numChildren = $('.ma-data-child').length - 1;

                    var $block = $(this).closest('.ma-child-block');
                    var $clone = $block.clone();
                    $block.find('.ma-add-child').hide();
                    $block.find('.ma-del-child').show();
                    $clone.find('.cloned-DatePicker').caDatePickerProUI();

                    $block.find('.form-fields').show();
                    $block.addClass('child-visible');

                    $block.data('id', '');
                    $block.find('input').val('');
                    $block.find('button').addClass('btn-alt');
                    $block.find('#ma_child_sex').caGenderToggle({});

                    if (self.options.children && self.options.children[numChildren]) {
                        $block.data('id', self.options.children[numChildren].id);
                        $block.find('input[name="child_first_name"]').val(self.options.children[numChildren].firstName);
                        $block.find('input[name="child_last_name"]').val(self.options.children[numChildren].lastName);

                        $block.find('#ma_child_sex').val(self.options.children[numChildren].sex);
                        $block.find('.gender-toggle-button button[data-value="' + self.options.children[numChildren].sex + '"]').removeClass('btn-alt');
                    }

                    $block.after($clone);

                    var count = $block.siblings('.child-visible').length + 1;
                    var max = self.options.maxDependents;
                    $clone.find('.ma-add-child').toggle(!(max > 0 && count >= max));
                });

                $form.on('click', '.ma-del-child', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var $block = $(this).closest('.ma-child-block');
                    var $last = $block.siblings('.ma-child-block').last();
                    $last.find('.ma-add-child').show();
                    $block.remove();
                });

                $form.on('click', '.ma-del-spouse', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var $block = $(this).closest('.ma-spouse-block');
                    $block.data('id', '');
                    $block.find('.ma-del-spouse').hide();
                    $block.find('.ma-add-spouse').show();
                    $block.find('.form-fields').hide();
                    $block.find('input').val('');
                    $block.find('button').addClass('btn-alt');
                });

                $form.on('click', '.ma-add-spouse', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var $block = $(this).closest('.ma-spouse-block');
                    $block.find('.ma-del-spouse').show();
                    $block.find('.ma-add-spouse').hide();
                    $block.find('.form-fields').show();
                });

                $form.on('reset', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    self.showPreloader();
                    $.get("/membership-application/info").done(function (data) {
                        $form.remove();
                        self.element.find('#ma-step1').html(data.html);
                        self.initStep1();
                        self.hidePreloader();
                    });
                });

                function showErrors(fields, prefix, pos) {
                    $.each(fields, function (key, value) {
                        var $formInput = $form.find('input[name=' + prefix + key + ']');

                        if (!$formInput.length) {
                            $formInput = $form.find('input[name="' + prefix + key + '[]"]');
                        }

                        if (pos != undefined) {
                            if (key == 'birthday') {
                                $formInput = $($formInput.get(parseInt(pos) * 3));
                            } else {
                                $formInput = $($formInput.get(pos));
                            }
                        }

                        var $container = $formInput.closest('.form-group');
                        $container.addClass('has-error');

                        var $errorBox = ($container.hasClass('js-birthday'))
                            ? $container.find('.error-box')
                            : $formInput.closest('.form-row').siblings('.error-box');

                        $errorBox.html('<div class="help-block animation-slideDown">' + value + '</div>');
                    });
                }

                function showOtherErrors(fields) {
                    $.each(fields, function (key, value) {
                        var $formInput = $form.find('input[name=' + key + ']');
                        $formInput.next('.help-block.animation-slideDown').remove();
                        $formInput.after($('<div class="help-block animation-slideDown">' + value + '</div>'));
                        $formInput.closest('.form-row').addClass('has-error');

                        $formInput = $form.find('select[name=' + key + ']');
                        $formInput.siblings('.help-block.animation-slideDown').remove();
                        $formInput.closest('.form-row').append(
                            $('<div class="help-block animation-slideDown">' + value + '</div>')
                        );
                        $formInput.closest('.form-row').addClass('has-error');
                    });
                }

                function clearErrors() {
                    $form.find('div.messages').remove();
                    $form.find('.help-block.animation-slideDown').remove();
                    $form.find('.error-box').empty();
                    $form.find('.form-group, .form-row').removeClass('has-error');
                }

                $form.on('submit', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var data = getData();
                    self.showPreloader();

                    $.ajax({
                        type: 'POST',
                        url: '/membership-application/info',
                        dataType: 'json',
                        data: data
                    }).done(function (data) {
                        clearErrors();

                        if (data.html) {
                            self.initStep2(data.html);
                            window.History.pushState(
                                {
                                    path: 'review-information'
                                },
                                'Review Information',
                                '/membership-application/review-information'
                            );
                        }

                        if (data.message) {
                            $form.prepend('<div class="messages">' + data.message + '</div>');
                        }

                        if (data.errors) {
                            if (data.errors.owner) {
                                showErrors(data.errors.owner, 'owner_');
                            }

                            if (data.errors.secondary) {
                                showErrors(data.errors.secondary, 'secondary_');
                            }

                            if (data.errors.children) {
                                $.each(data.errors.children, function (pos, childErr) {
                                    showErrors(childErr, 'child_', pos);
                                });
                            }

                            if (data.errors.other) {
                                showOtherErrors(data.errors.other);
                            }
                        }
                    }).always(function () {
                        self.hidePreloader();
                    });
                });
            }

            setupDefaultConfiguration();
            setupFormHandlers();

            var canUseCustomSelect = (function () {
                if (window.navigator.appName === "Microsoft Internet Explorer") {
                    return document.documentMode >= 8;
                }

                if (/iP(od|hone)/i.test(window.navigator.userAgent)
                    || (/Android/i.test(window.navigator.userAgent) && /Mobile/i.test(window.navigator.userAgent))) {
                    return false;
                }

                return true;
            })();

            if (canUseCustomSelect) {
                $form.find('.ma-select').removeClass('ma-select');
            }

            // initialize Chosen
            $form.find('.select-chosen')
                .chosen({
                    width: '100%',
                    disable_search_threshold: 10
                })
                .change(function () {
                    if ($(this).val() == '') {
                        $(this).addClass('placeholder');
                    } else {
                        $(this).removeClass('placeholder');
                    }
                })
                .trigger('change');

            var $phones = $form.find('#ma_home_phone, #ma_work_phone, #ma_cell_phone, #ma_emerg_phone');

            setInterval(function () {
                $phones.each(function () {
                    if (this.value.length > 0 && !this.value.match(/^\d+$/)) {
                        this.value = this.value.replace(/\D/g, '');
                    }
                });
            }, 100);

            function showCustomError($field, msg) {
                if (msg) {
                    $field.next('.help-block.animation-slideDown').remove();
                    $field.after($('<div class="help-block animation-slideDown">' + DOMPurify.sanitize(msg) + '</div>'));
                    $field.closest('.form-row').addClass('has-error');
                } else {
                    $field.closest('.form-row').removeClass('has-error');
                    $field.next().filter('.help-block.animation-slideDown').remove();
                }
            }

            $form.find('#ma_emerg_phone').on('blur', function () {
                var $field = $(this);
                var msg = 'Value is required and must be a 10-digit number';
                var valid = (this.value.length == 10 && this.value.match(/^\d+$/));
                showCustomError($field, valid ? null : msg);
            });

            $form.find('#ma_work_phone, #ma_cell_phone').on('blur', function () {
                var $field = $(this);
                var msg = 'Value must be a 10-digit number';
                var valid = !(this.value.length > 0 && (this.value.length != 10 || !this.value.match(/^\d+$/)));
                showCustomError($field, valid ? null : msg);
            });

            $form.find('#ma_email').on('change', function () {
                var $field = $(this);

                $.getJSON('/membership-application/check-email', {
                    email: this.value
                }).done(function (data) {
                    showCustomError($field, data.errors);
                });
            });

            $form.find('#ma_password').caPassword();
            $form.find('#ma_password').on('caPassword:validate', function (e, msg) {
                showCustomError($(this), msg);
            });

            $form.find('#ma_password_confirm').on('blur', function () {
                var password = $('#ma_password').val();
                var msg = password != this.value ? 'Passwords do not match' : null;
                showCustomError($(this), msg);
            });

            var promoCodeField = $form.find('#ma_employer_promo_code');
            promoCodeField.on('change', function () {
                var $field = $(this);
                if (this.value == '') {
                    $field.closest('.form-row').removeClass('has-error');
                    $field.next().filter('.help-block.animation-slideDown').remove();
                    $('#ma_employer').val('');

                    return;
                }

                $.getJSON(
                    '/membership-application/check-promo-code',
                    {
                        code: this.value
                    }
                ).done(function (data) {
                    if (data.errors == 0) {
                        $field.closest('.form-row').removeClass('has-error');
                        $field.next().filter('.help-block.animation-slideDown').remove();

                        if (data.employer) {
                            $('#ma_employer').val(data.employer);
                        }
                    } else {
                        $field.next('.help-block.animation-slideDown').remove();
                        $field.after($('<div class="help-block animation-slideDown">' + DOMPurify.sanitize(data.msg) + '</div>'));
                        $field.closest('.form-row').addClass('has-error');
                        $('#ma_employer').val('');
                    }
                });
            });

            if (promoCodeField.val() !== '') {
                promoCodeField.trigger('change');
            }

            $form.find('input[name=owner_first_name]').focus();
        },

        initStep2: function (data) {
            this.setActiveTab(2);
            var $step1 = this.element.find('#ma-step1');
            var $step2 = this.element.find('#ma-step2');
            $step1.hide();
            $step2.html(data).show();
            var $form = $step2.find('>form');
            var self = this;

            $form.find('.ma-btn-edit').on('click', function () {
                History.back();

                var $el = $(this);
                setTimeout(function () {
                    var block = $el.data('block');
                    var $block = $step1.find(".ma-data-" + block);

                    if (block == 'child') {
                        var pos = +$el.data('block-pos');
                        if (pos > 0) {
                            $block = $($step1.find(".ma-data-" + block).get(pos - 1));
                        }
                    }

                    var offset = $block.offset().top;
                    if (!self.options.iframe) {
                        offset -= 40;
                    }

                    $('html, body').animate({
                        scrollTop: offset
                    }, 1000);

                    $block.find('input[type=text]').first().focus();
                }, 500);
            });

            $form.on('reset', function (e) {
                e.preventDefault();
                e.stopPropagation();
                History.back();
                $('html, body').animate({
                    scrollTop: 0
                }, 1000);
            });

            $form.on('submit', function (e) {
                e.preventDefault();
                e.stopPropagation();
                self.showPreloader();

                $form.find('div.messages').remove();
                if (self.options.hasContract) {
                    $.ajax({
                        type: 'GET',
                        url: '/membership-application/contract',
                        dataType: 'json'
                    }).done(function (data) {
                        if (data.html) {
                            self.initStep3(data.html);

                            window.History.pushState(
                                {
                                    path: 'electronic-contract'
                                },
                                'Electronic Contract',
                                '/membership-application/electronic-contract'
                            );
                        }

                        if (data.message) {
                            $form.prepend('<div class="messages">' + data.message + '</div>');
                        }
                    }).always(function () {
                        self.hidePreloader();
                    });
                } else {
                    $.ajax({
                        type: 'GET',
                        url: '/membership-application/payment',
                        dataType: 'json'
                    }).done(function (data) {
                        if (data.html) {
                            self.initStep4(data.html);
                            window.History.pushState(
                                {
                                    path: 'payment-screen'
                                },
                                'Payment',
                                '/membership-application/payment-screen'
                            );
                        }
                        if (data.message) {
                            $form.prepend('<div class="messages">' + data.message + '</div>');
                        }
                    }).always(function () {
                        self.hidePreloader();
                    });
                }
            });
        },

        initStep3: function (data) {
            this.setActiveTab(3);
            this.element.find('>.step').hide();

            var $step = this.element.find('#ma-step3');
            $step.html(data).show();

            var $form = $step.find('form');
            var self = this;

            $form.on('reset', function (e) {
                e.preventDefault();
                e.stopPropagation();
                History.back();
            });

            function clearErrors() {
                $form.find('div.messages').remove();
                $form.find('.help-block.animation-slideDown').remove();
                $form.find('.error-box').empty();
                $form.find('.form-group, .form-row').removeClass('has-error');
            }

            function showErrors(fields) {
                $.each(fields, function (key, value) {
                    if (key == 'signature') {
                        var $f = $form.find('input[name=' + key + ']');
                        $f.next('.help-block.animation-slideDown').remove();
                        $f.after($('<div class="help-block animation-slideDown">' + value + '</div>'));
                        $f.closest('.form-row').addClass('has-error');
                    } else {
                        var $f = $form.find('input[type="hidden"][name=' + key + ']');
                        var $row = $f.closest('.labeled-checkbox');
                        $row.addClass('has-error');
                        $row.append($('<div class="help-block animation-slideDown">' + value + '</div>'));
                    }
                });
            }

            $form.on('submit', function (e) {
                e.preventDefault();
                e.stopPropagation();
                self.showPreloader();

                $form.find('div.messages').remove();
                $.ajax({
                    type: "POST",
                    url: "/membership-application/contract",
                    dataType: 'json',
                    data: $form.find(':input').serializeArray()
                }).done(function (data) {
                    clearErrors();

                    if (data.html) {
                        self.initStep4(data.html);
                        window.History.pushState(
                            {
                                path: 'payment-screen'
                            },
                            'Payment',
                            '/membership-application/payment-screen'
                        );
                    }

                    if (data.message) {
                        $form.prepend('<div class="messages">' + data.message + '</div>');
                    }

                    if (data.errors) {
                        showErrors(data.errors);
                    }
                }).always(function () {
                    self.hidePreloader();
                });
            });
        },

        initStep4: function (data) {
            var tabNumber = this.options.hasContract ? 4 : 3;
            this.setActiveTab(tabNumber);
            this.element.find('>.step').hide();

            var $step = this.element.find('#ma-step4');
            $step.html(data).show();

            var $form = $step.find('form');
            var self = this;

            $form.on('reset', function (e) {
                e.preventDefault();
                e.stopPropagation();
                History.back();
            });

            function clearErrors() {
                $form.find('div.messages').remove();
                $form.find('.help-block.animation-slideDown').remove();
                $form.find('.error-box').empty();
                $form.find('.form-group, .form-row').removeClass('has-error');
            }

            function showErrors(fields) {
                var monthError = false;

                $.each(fields, function (key, value) {
                    // get first property from error object
                    value = value[Object.keys(value)[0]];

                    if (key == 'err_output' || key == 'err_message' || key == 'err_fields') {
                        if (key == 'err_message') {
                            var $msg = $('<div class="messages">' + value + '</div>');
                            $form.prepend($msg);
                            $('html, body').animate(
                                {
                                    scrollTop: $msg.offset().top
                                },
                                500
                            );
                        }

                        return;
                    }

                    // inputs
                    var $formInput = $form.find('input[name=' + key + ']');

                    if (key == 'eft_auth_accept') {
                        var $row = $formInput.closest('.labeled-checkbox');
                        $row.addClass('has-error');
                        $row.append($('<div class="help-block animation-slideDown">' + value + '</div>'));
                    } else {
                        if (key == 'card_number') {
                            $formInput.closest('.form-row').append(
                                $('<div class="help-block animation-slideDown">' + value + '</div>')
                                    .css('clear', 'both')
                            );
                        } else {
                            $formInput.after(
                                $('<div class="help-block animation-slideDown">' + value + '</div>')
                            );
                        }

                        $formInput.closest('.form-row').addClass('has-error');
                    }

                    // selects
                    if (key == 'month') {
                        key = 'year';
                        monthError = true;
                    }

                    $formInput = $form.find('select[name=' + key + ']');
                    $formInput.siblings('.help-block.animation-slideDown').remove();
                    $formInput.parent().append($('<div class="help-block animation-slideDown">' + value + '</div>'));
                    $formInput.closest('.form-row').addClass('has-error');
                });
            }

            function sendData($form) {
                $.ajax({
                    type: 'POST',
                    url: '/membership-application/payment',
                    dataType: 'html',
                    data: $form.find(':input').serializeArray()
                }).done(function (json) {
                    clearErrors();

                    var data = $.parseJSON(json);

                    if (data.errors || data.message) {
                        if (data.errors) {
                            showErrors(data.errors);
                        }

                        if (data.message) {
                            showErrors({'err_message': [data.message]});
                        }
                    } else {
                        window.History.pushState(
                            {
                                path: 'thank-you'
                            },
                            'Thank You',
                            '/membership-application/thank-you'
                        );
                    }
                }).always(function () {
                    self.hidePreloader();
                });
            }

            function getInfrastructureFeesPreview(paymentMethodType, params) {
                if (typeof (params.token) === 'undefined') {
                    return false;
                }
                const token = params.token;
                jQuery('.ca-loading-splash-container').css('display', 'block');
                jQuery('.overlay_layer').css('display', 'block');
                const url = '/membership-application/get-preview?&ajax=true';
                new Ajax.Request(
                    url,
                    {
                        method: 'post',
                        parameters: {paymentMethodType, token},
                        onComplete(response) {
                            jQuery('.ca-loading-splash-container').css('display', 'none');
                            jQuery('.overlay_layer').css('display', 'none');
                            const responseJson = JSON.parse(response.responseText);
                            if (typeof (responseJson.infrastructureFees) !== 'undefined') {
                                jQuery('.infrastructure-fees').html(`$${responseJson.infrastructureFees}`);
                                jQuery('.grand-total').html(`$${responseJson.grandTotal}`);
                            }
                        },
                        onFailure() {
                            jQuery('.ca-loading-splash-container').css('display', 'none');
                            jQuery('.overlay_layer').css('display', 'none');
                            jQuery.caAlert('fail');
                        },
                    },
                );
            }

            $form.on('submit', function (e) {
                e.preventDefault();
                e.stopPropagation();
                self.showPreloader();
                $form.find('div.messages').remove();

                var $paymentMethod = $form.find('#ma_payment_method');

                if ($paymentMethod.val() == HC_CARD) {
                    var cardConnectIsActive = $j('#cardconnect_active').val() === '1';
                    var ccMerchant = '';
                    if (cardConnectIsActive) {
                        ccMerchant = new CardConnect();
                    } else {
                        ccMerchant = new I4go();
                    }

                    if (!cardConnectIsActive) {
                        ccMerchant.formChange($form, function (result) {
                            if (!result) {
                                self.hidePreloader();
                                return false;
                            }
                            sendData($form);
                        });
                    } else {
                        sendData($form);
                    }
                } else {
                    sendData($form);
                }
            });

            var canUseCustomSelect = (function () {
                if (window.navigator.appName === "Microsoft Internet Explorer") {
                    return document.documentMode >= 8;
                }
                if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
                    return false;
                }
                if (/Android/i.test(window.navigator.userAgent)) {
                    if (/Mobile/i.test(window.navigator.userAgent)) {
                        return false;
                    }
                }
                return true;
            })();

            if (canUseCustomSelect) {
                $form.find('.ma-select').removeClass('ma-select');
            }

            if (!$('#ma_country_code').length) {
                $form.find('#ma_state, #ma_payment_state').chosen({
                    width: '100%',
                    disable_search_threshold: 10
                });
            }

            var $payment_method_row = $form.find('.ma-payment-method');
            var $bank_fields = $form.find('.ma-payment-account, .ma-payment-account2, .ma-payment-routing');
            var $card_fields = $form.find('.ma-payment-cardnumber, .ma-payment-security, .ma-payment-date');
            var $card_conenct_fields = $form.find('.ma-payment-cardconnectnumber, .ma-payment-cardconnect-date');
            var isCardEnabled = ($form.find('input[name=card_enabled]').val() == 1);
            var isBankEnabled = ($form.find('input[name=bank_enabled]').val() == 1);
            var isCardConnectEnabled = ($form.find('input[name=cardConnect_enabled]').val() == 1);
            var isCashFlowEnabled = ($form.find('input[name=cashFlow_enabled]').val() == 1);
            var isAchCashFlowEnabled = ($form.find('input[name=ach_cashFlow_enabled]').val() == 1);

            $payment_method_row.hide();
            $bank_fields.hide();
            $card_fields.hide();
            $card_conenct_fields.hide();

            if ((isCardEnabled && isBankEnabled) || $payment_method_row.find('option').length > 2) {
                $payment_method_row.show();
            }

            if (isCardEnabled || isBankEnabled) {
                $payment_method_row.show();
            }

            $form.find('#ma_card_number').on('error', function (ui, msg) {
                showErrors(msg);
            });

            $form.find('#ma_routing_number').on('blur', function () {
                $(this).parent().find('.help-block.animation-slideDown').remove();
                $(this).parent().removeClass('has-error');
                var routingNumberPattern = $('#ma_is_canadian_ach_enabled').val() ?
                    /^\d{8}$/ : /^\d{9}$/;

                if (!routingNumberPattern.test(this.value) && !$form.find('#ach_cashFlow_enabled').val()) {
                    showErrors({
                        routing_number: ["Please enter a valid routing number"]
                    });
                }
            });

            $form.find('#ma_account_number2').on('blur', function () {
                var fields = $(this).parent().add($('#ma_account_number').parent());
                fields.find('.help-block.animation-slideDown').remove();
                fields.removeClass('has-error');

                if (this.value != $('#ma_account_number').val()) {
                    showErrors({
                        account_number: ["Account numbers do not match"],
                        account_number2: ["Account numbers do not match"]
                    });
                }
            });

            $form.find('#update-cc').on('click', function () {
                if (isCardConnectEnabled === true) {
                    cpac.user.billing.cardConnectDialogCall();
                } else if (isCashFlowEnabled === true) {
                    cpac.user.billing.cashFlowDialogCall(function (form, params) {
                        getInfrastructureFeesPreview(HC_CARD, params);
                    });
                }
            });

            $form.find('#update-bank').on('click', function () {
                if (isAchCashFlowEnabled === true) {
                    cpac.user.billing.cashFlowDialogCallBank(function (form, params) {
                        getInfrastructureFeesPreview(HC_BANKACC, params);
                    });
                }
            });

            $form.find('#ma_payment_method').val('');
            $form.find('#ma_payment_method').chosen({
                width: '100%',
                disable_search_threshold: 10,
                display_selected_options: false,
            }).change(function () {
                var selected = $form.find('#ma_payment_method').val();
                if (selected === HC_CARD && isCardConnectEnabled) {
                    cpac.user.billing.cardConnectDialogCall();
                    $bank_fields.hide();
                    $card_fields.hide();
                    $card_conenct_fields.show();
                } else if (selected === HC_CARD && isCashFlowEnabled) {
                    $form.find('input[name=paymenttype]').val('card');
                    cpac.user.billing.cashFlowDialogCall(function (form, params) {
                        getInfrastructureFeesPreview(HC_CARD, params);
                    });
                    $bank_fields.hide();
                    $card_fields.hide();
                    $card_conenct_fields.show();
                } else if (selected === HC_BANKACC && isAchCashFlowEnabled) {
                    $form.find('input[name=paymenttype]').val('bank');
                    cpac.user.billing.cashFlowDialogCallBank(function (form, params) {
                        getInfrastructureFeesPreview(HC_BANKACC, params);
                    });
                    $form.find('[name=account_number]').prop("readonly", true);
                    $form.find('[name=routing_number]').prop("readonly", true);
                    $bank_fields.show();
                    $card_fields.hide();
                    $card_conenct_fields.hide();
                } else {
                    switch (selected) {
                        case HC_CARD:
                            $bank_fields.hide();
                            $card_fields.show();
                            $card_conenct_fields.hide();
                            break;
                        case HC_BANKACC:
                            $bank_fields.show();
                            $card_fields.hide();
                            $card_conenct_fields.hide();
                            break;
                        default:
                            $bank_fields.hide();
                            $card_fields.hide();
                            $card_conenct_fields.hide();
                    }
                }
            });

            $form.find('#ma_year').chosen({
                width: '80px',
                disable_search_threshold: 10
            });

            $form.find('#ma_month').chosen({
                width: '90px',
                disable_search_threshold: 10
            });

            $form.find('input[name=bill_name]').focus();
        },

        updateSecondary: function (secondary) {
            this.options.secondary = secondary;

            if (this.options.withSecondary && secondary) {
                var $secondaryBlock = $('.ma-data-spouse');

                $secondaryBlock.data('id', secondary.id);
                $secondaryBlock.find('input[name="secondary_first_name"]').val(secondary.firstName);
                $secondaryBlock.find('input[name="secondary_last_name"]').val(secondary.lastName);

                var birthday = secondary.birthDate.split('/');
                $secondaryBlock.find('#ma_secondary_birthday_month').val(birthday[0]);
                $secondaryBlock.find('#ma_secondary_birthday_day').val(birthday[1]);
                $secondaryBlock.find('#ma_secondary_birthday_year').val(birthday[2]);

                $secondaryBlock.find('#ma_secondary_gender').val(secondary.sex);
                $secondaryBlock.find('.gender-toggle-button button[data-value="' + secondary.sex + '"]').trigger('click');
            }
        },

        updateChildren: function (children) {
            this.options.children = children;

            if (this.options.withDependents && children && children[0]) {
                var $childBlock = $('.ma-data-child');

                $childBlock.data('id', children[0].id);
                $childBlock.find('input[name="child_first_name"]').val(children[0].firstName);
                $childBlock.find('input[name="child_last_name"]').val(children[0].lastName);

                var birthday = children[0].birthDate.split('/');
                $childBlock.find('#ma_child_birthday_month').val(birthday[0]);
                $childBlock.find('#ma_child_birthday_day').val(birthday[1]);
                $childBlock.find('#ma_child_birthday_year').val(birthday[2]);

                $childBlock.find('#ma_child_gender').val(children[0].sex);
                $childBlock.find('.gender-toggle-button button[data-value="' + children[0].sex + '"]').trigger('click');
            }
        }
    });
})(jQuery);
